import React, { useEffect, useState } from "react";
import ReviewCard from "./ReviewCard";
import '../styles/Review.css';

const ReviewsList = () => {
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState(false);

  const shuffleArray = (array) => {
    return array
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
  };

  useEffect(() => {
    const fetchReviews = async () => {
      const url = `${process.env.REACT_APP_URL_SCHEME}${process.env.REACT_APP_IP_ADDRESS}/api/reviews`;
    
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.result.reviews) {
          const shuffled = shuffleArray(data.result.reviews);
          setReviews(shuffled);
        } else {
          console.error("No reviews found in response.");
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setError(true);
      }
    };    
    fetchReviews();
  }, []);

  return (
    <div className="reviews-container" id="reviews">
        <h1>Our Guest Google Reviews</h1>
        <h4>Your feedbacks are valuable to us.</h4>
    <div className="reviews-box">
      {reviews.length > 0 ? (
        reviews.slice(0, 3).map((review, index) => <ReviewCard key={index} review={review} />)
      ) : (!error ? <div className='loading-container'>
                      <div className="spinner"></div>
                      <p className="loading">Loading reviews...</p>
                    </div> : <p className="error">Found an error in fetching reviews.</p>
      )}
    </div>
        <div className="button-container">
        {!error? <button className="review-button"
            onClick={() => window.open(`https://search.google.com/local/writereview?placeid=${process.env.REACT_APP_PLACE_ID}`)}>
            More Reviews
        </button> : ""}
        </div>
    </div>
  );
};

export default ReviewsList;
